export enum Selection {
  Single = 'single',
  Multiple = 'multiple',
}
